import React from 'react';
import { Link } from 'react-router-dom';
import { Eye, FileDown } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Checkbox } from '../../ui/checkbox';
import { formatPrice, formatDateTime, ORDER_STATUS } from '../../../lib/utils';
import { Pagination } from '../../Pagination';

export const OrdersTable = ({
    orders,
    totalOrders,
    searchQuery,
    selectedOrders,
    onToggleOrder,
    onToggleAll,
    onStatusChange,
    onDownloadPdf,
    currentPage,
    totalPages,
    setCurrentPage,
}) => (
    <Card>
        <CardHeader>
            <CardTitle className="font-heading">
                {totalOrders} commande{totalOrders !== 1 ? 's' : ''}
                {searchQuery && <span className="text-sm font-normal text-muted-foreground ml-2">pour "{searchQuery}"</span>}
            </CardTitle>
        </CardHeader>
        <CardContent>
            {orders.length > 0 ? (
                <div className="overflow-x-auto">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead className="w-10">
                                    <Checkbox
                                        checked={orders.length > 0 && selectedOrders.size === orders.length}
                                        onCheckedChange={onToggleAll}
                                        data-testid="select-all-checkbox"
                                    />
                                </TableHead>
                                <TableHead>N° Commande</TableHead>
                                <TableHead>Client</TableHead>
                                <TableHead>Date</TableHead>
                                <TableHead>Articles</TableHead>
                                <TableHead>Total</TableHead>
                                <TableHead>Statut</TableHead>
                                <TableHead></TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {orders.map((order) => (
                                <TableRow key={order.id} data-testid={`order-${order.id}`} className={selectedOrders.has(order.id) ? 'bg-amber-50' : ''}>
                                    <TableCell>
                                        <Checkbox
                                            checked={selectedOrders.has(order.id)}
                                            onCheckedChange={() => onToggleOrder(order.id)}
                                            data-testid={`select-order-${order.id}`}
                                        />
                                    </TableCell>
                                    <TableCell className="font-medium">{order.order_number}</TableCell>
                                    <TableCell>{order.company_name}</TableCell>
                                    <TableCell>{formatDateTime(order.created_at)}</TableCell>
                                    <TableCell>{order.items?.length || 0} article(s)</TableCell>
                                    <TableCell className="font-semibold">{formatPrice(order.total)}</TableCell>
                                    <TableCell>
                                        <Select
                                            value={order.status}
                                            onValueChange={(value) => onStatusChange(order.id, value)}
                                        >
                                            <SelectTrigger className="w-[140px]">
                                                <SelectValue />
                                            </SelectTrigger>
                                            <SelectContent>
                                                {Object.entries(ORDER_STATUS).map(([key, { label }]) => (
                                                    <SelectItem key={key} value={key}>{label}</SelectItem>
                                                ))}
                                            </SelectContent>
                                        </Select>
                                    </TableCell>
                                    <TableCell className="flex gap-1">
                                        <Button asChild variant="ghost" size="sm">
                                            <Link to={`/admin/commande/${order.id}`}>
                                                <Eye className="h-4 w-4 mr-1" />
                                                Détails
                                            </Link>
                                        </Button>
                                        <Button variant="ghost" size="sm" onClick={() => onDownloadPdf(order.id, order.order_number)} data-testid={`pdf-${order.id}`}>
                                            <FileDown className="h-4 w-4 mr-1" />
                                            PDF
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            ) : (
                <div className="text-center py-12 text-muted-foreground">
                    Aucune commande trouvée
                </div>
            )}
        </CardContent>
        <Pagination currentPage={currentPage} totalPages={totalPages} totalItems={totalOrders} setCurrentPage={setCurrentPage} label="commandes" />
    </Card>
);
